"use client"

import { useEffect } from "react"

import { useNativeBridge } from "@/platform/bridge/use-native-bridge"
import { applyNativeRumSession, clearNativeRumSession } from "@/platform/observability/datadog/native-rum-stitch"

export const AppModeTelemetry = () => {
  const bridge = useNativeBridge()

  useEffect(() => {
    if (!bridge.available) return

    const off = bridge.on("rum.session", (data) => {
      applyNativeRumSession(data)
    })
    return () => {
      off()
      clearNativeRumSession()
    }
  }, [bridge])

  return null
}
